import { render, staticRenderFns } from "./commissionCreate.vue?vue&type=template&id=4323b994&scoped=true"
import script from "./commissionCreate.vue?vue&type=script&lang=js"
export * from "./commissionCreate.vue?vue&type=script&lang=js"
import style0 from "./commissionCreate.vue?vue&type=style&index=0&id=4323b994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4323b994",
  null
  
)

export default component.exports